import { GRADES_LIST_SUCCESS } from "./GradesConstant";



export const gradesReducer = (state = { gradesData: [] }, action) => {

    switch (action.type) {
        case GRADES_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                gradesData: action.payload,
            }
        default:
            return state;
    }

}



